<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Layout from '@layouts/main.vue'
import WidgetProfileHead from '@widgets/widget-profile-head.vue'
import PlayerProfilePrimaryWidgets from '@/src/components/player-profile-primary-widgets.vue'
import PlayerProfileSecondaryWidgets from '@/src/components/player-profile-secondary-widgets.vue'
import WidgetSimilarPlayers from '@widgets/widget-similar-players.vue'
import FabScrollTop from '@components/fab-scroll-top.vue'

export default {
  page() {
    return {
      title: this.player.name,
      meta: [
        {
          name: 'description',
          content: `The user profile for ${this.player.name}.`,
        },
      ],
    }
  },
  components: {
    Layout,
    WidgetProfileHead,
    PlayerProfilePrimaryWidgets,
    PlayerProfileSecondaryWidgets,
    WidgetSimilarPlayers,
    FabScrollTop,
  },
  props: {
    initPlayer: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      player: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    ...mapGetters('players', ['getSearchBoxPlayerA']),
    ...mapGetters('ui', {
      defaultSeason: 'getDefaultSeason',
    }),
  },
  watch: {
    defaultSeason: function() {
      this.loadPlayerData()
    },
  },
  destroyed() {
    this.setPlayerSearchBoxA(null)
  },
  created() {
    this.player = this.initPlayer
  },
  methods: {
    ...mapActions('players', ['getSinglePlayerById']),
    ...mapMutations('players', ['setPlayerSearchBoxA']),
    loadPlayerData() {
      const playerId = this.getSearchBoxPlayerA.id

      this.getSinglePlayerById({ id: playerId }).then((result) => {
        this.player = result
      })
    },
  },
}
</script>

<template>
  <Layout v-if="player">
    <v-container fluid :class="$style.container">
      <h2 class="text-h6 pb-2">
        {{ $t('player_profile') }}
      </h2>
      <WidgetProfileHead :player="player" />
      <PlayerProfilePrimaryWidgets :player="player" />
      <PlayerProfileSecondaryWidgets v-if="loggedIn" :player="player" />

      <WidgetSimilarPlayers v-if="loggedIn" :player-id="player.id" />
    </v-container>
    <FabScrollTop />
  </Layout>
  <Layout v-else>
    <h1>
      <BaseIcon name="user" />

      No player found :(
    </h1>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.doubleRow {
  display: flex;
  flex-direction: column;

  @media screen and (max-width: $screen-lg) {
    // padding: 12px 0;
    article + article {
      padding-top: 1rem;
    }
  }
}

.container {
  // padding: 0;
}

.playerGoals {
  flex-grow: 1;
}
</style>
